import {RegionSelectorProps, regionsSelector, useGetAllRegionsQuery} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {BaseRegionMultiSelect, BaseRegionMultiSelectProps} from "./BaseRegionMultiSelect";

export type RegionMultiSelectProps = Omit<BaseRegionMultiSelectProps, "entities" | "loading"> & {
  selector?: RegionSelectorProps
}

export const RegionMultiSelect = (props: RegionMultiSelectProps) => {
  const {selector, ...rest} = props;

  const selectRegions = useMemo(() => {
    return regionsSelector();
  }, []);

  const {regions, isLoading} = useGetAllRegionsQuery(undefined, {
    selectFromResult: (result) => ({
      regions: selectRegions(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseRegionMultiSelect entities={regions} loading={isLoading} {...rest} />;
};
